import { ADD_PROFILE_DETAILS, ADD_PROFILE_IMAGE, USER_ID, ACCESS } from './action';
import avatar from "../../assets/images/default-avatar.jpg";

const initialState = {
  profile_setting: avatar,
  user_id: "",
  access: []
};

export const profileReducer = (state = initialState, action: any) => {

  switch (action.type) {
    case ADD_PROFILE_DETAILS:
      return {
        ...state,
        profile_setting: action.payload,
      };
    case ADD_PROFILE_IMAGE:
      return {
        ...state,
        profile_setting: action.payload.file,
      };
    case USER_ID:
      return {
        ...state,
        user_id: action.payload
      }
    case ACCESS:
      console.log("access", action);
      return {
        ...state,
        access: action.payload
      }
    default:
      return state;
  }
};
